var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21V51M13.5 21H31.5L34.5 24H40.5L43.5 21H55.5L61.5 27V45L55.5 51H43.5L40.5 48H34.5L31.5 51H13.5M13.5 21V16.5M13.5 51V55.5",
    stroke: "#A80A01",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 21H43.5",
    stroke: "#A80A01",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 51H43.5",
    stroke: "#A80A01",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 27,
    width: 3,
    height: 6,
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 39,
    width: 3,
    height: 6,
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 36C33.5 31.5817 29.9183 28 25.5 28C21.0817 28 17.5 31.5817 17.5 36C17.5 40.4183 21.0817 44 25.5 44C29.9183 44 33.5 40.4183 33.5 36Z",
    stroke: "#A80A01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1002 30.8001C27.1002 32.0001 28.3002 33.2001 27.1002 34.8001V35.6001C29.5002 33.2001 30.2002 32.4001 28.7002 31.2001C26.7002 29.6001 23.8634 30.0585 25.1002 30.8001Z",
    stroke: "#A80A01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8882 41.1217C23.8882 39.9217 22.6882 38.7217 23.8882 37.1217V36.3217C21.4882 38.7217 20.7882 39.5217 22.2882 40.7217C24.2882 42.3217 26.6554 41.8295 25.8882 41.1217Z",
    stroke: "#A80A01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3338 36.3553C21.5338 34.3553 22.7338 33.1553 24.3338 34.3553H25.1338C22.7338 31.9553 21.9338 31.2553 20.7338 32.7553C19.1338 34.7553 19.5914 37.5921 20.3338 36.3553Z",
    stroke: "#A80A01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6554 35.5665C29.4554 37.5665 28.2554 38.7665 26.6554 37.5665H25.8554C28.2554 39.9665 29.0554 40.6673 30.2554 39.1665C31.8554 37.1665 31.397 34.3297 30.6554 35.5665Z",
    stroke: "#A80A01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 37.6C25.9242 37.6 26.3312 37.4315 26.6313 37.1314C26.9313 36.8313 27.0999 36.4244 27.0999 36C27.0999 35.5757 26.9313 35.1687 26.6313 34.8687C26.3312 34.5686 25.9242 34.4 25.4999 34.4C25.0756 34.4 24.6686 34.5686 24.3685 34.8687C24.0685 35.1687 23.8999 35.5757 23.8999 36C23.8999 36.4244 24.0685 36.8313 24.3685 37.1314C24.6686 37.4315 25.0756 37.6 25.4999 37.6Z",
    stroke: "#A80A01"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 36C57.5 31.5817 53.9183 28 49.5 28C45.0817 28 41.5 31.5817 41.5 36C41.5 40.4183 45.0817 44 49.5 44C53.9183 44 57.5 40.4183 57.5 36Z",
    stroke: "#A80A01"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1002 30.8001C51.1002 32.0001 52.3002 33.2001 51.1002 34.8001V35.6001C53.5002 33.2001 54.2002 32.4001 52.7002 31.2001C50.7002 29.6001 47.8634 30.0585 49.1002 30.8001Z",
    stroke: "#A80A01"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8882 41.1217C47.8882 39.9217 46.6882 38.7217 47.8882 37.1217V36.3217C45.4882 38.7217 44.7882 39.5217 46.2882 40.7217C48.2882 42.3217 50.6554 41.8295 49.8882 41.1217Z",
    stroke: "#A80A01"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3338 36.3553C45.5338 34.3553 46.7338 33.1553 48.3338 34.3553H49.1338C46.7338 31.9553 45.9338 31.2553 44.7338 32.7553C43.1338 34.7553 43.5914 37.5921 44.3338 36.3553Z",
    stroke: "#A80A01"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6554 35.5665C53.4554 37.5665 52.2554 38.7665 50.6554 37.5665H49.8554C52.2554 39.9665 53.0554 40.6673 54.2554 39.1665C55.8554 37.1665 55.397 34.3297 54.6554 35.5665Z",
    stroke: "#A80A01"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4999 37.6C49.9242 37.6 50.3312 37.4315 50.6313 37.1314C50.9313 36.8313 51.0999 36.4244 51.0999 36C51.0999 35.5757 50.9313 35.1687 50.6313 34.8687C50.3312 34.5686 49.9242 34.4 49.4999 34.4C49.0756 34.4 48.6686 34.5686 48.3685 34.8687C48.0685 35.1687 47.8999 35.5757 47.8999 36C47.8999 36.4244 48.0685 36.8313 48.3685 37.1314C48.6686 37.4315 49.0756 37.6 49.4999 37.6Z",
    stroke: "#A80A01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpu);
export default __webpack_public_path__ + "static/media/GPU.1a7fb44ebc3297e7628a59aa3a062edc.svg";
export { ForwardRef as ReactComponent };